"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSurveyTransparencyContentToJSON = exports.AdSurveyTransparencyContentFromJSONTyped = exports.AdSurveyTransparencyContentFromJSON = exports.instanceOfAdSurveyTransparencyContent = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AdSurveyTransparencyContent interface.
 */
function instanceOfAdSurveyTransparencyContent(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdSurveyTransparencyContent = instanceOfAdSurveyTransparencyContent;
function AdSurveyTransparencyContentFromJSON(json) {
    return AdSurveyTransparencyContentFromJSONTyped(json, false);
}
exports.AdSurveyTransparencyContentFromJSON = AdSurveyTransparencyContentFromJSON;
function AdSurveyTransparencyContentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transparencyUrl': !(0, runtime_1.exists)(json, 'transparency_url') ? undefined : json['transparency_url'],
        'transparencyLabel': !(0, runtime_1.exists)(json, 'transparency_label') ? undefined : json['transparency_label'],
    };
}
exports.AdSurveyTransparencyContentFromJSONTyped = AdSurveyTransparencyContentFromJSONTyped;
function AdSurveyTransparencyContentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transparency_url': value.transparencyUrl,
        'transparency_label': value.transparencyLabel,
    };
}
exports.AdSurveyTransparencyContentToJSON = AdSurveyTransparencyContentToJSON;
